<template>
  <div class="workers-block" v-show="order.status != null">
    <div class="string" v-for="(service, serviceIndex) in serviceArray"
         v-if="service.worker != null"
         @click.stop="">
      <div class="worker visibility">
        <span class="numb">{{ (serviceIndex + 1) + '.' }}</span>
        <span class="name">{{ service.worker.surname + ' ' + service.worker.name + ' ' + service.worker.patronymic }}</span>&nbsp;
        <span class="brigadier" v-if="isWorkerBrigadier(service.worker)">бригадир</span>&nbsp;
        <span class="beginner" v-if="isWorkerNewbie(service.worker)">новичок</span>&nbsp;
        <div class="rating">
          <div class="rating-wrapper">
            <div class="filling" :style="'width: ' + service.worker.rating * 20 + '%'"></div>
            <div class="stars"></div>
          </div>
        </div>
        <span class="phone">{{ service.worker.phone }}</span>
        <div class="functional-buttons">
                                                <span class="call-button" title="Позвонить"
                                                      @click.stop="editable ? callWorker(service.worker) : ''"><img
                                                  src="../image/phone-call.svg"></span>
          <div class="view-status" v-show="service.worker != null" v-if="isServicePrimary(service)">
                                                  <span
                                                    :class="{status: true, 'active-status': true, send: service.status == 1, delivered: service.status == 2, confirmed: service.status == 3}"
                                                    :title="getServiceStatusTitle(service)"
                                                    @click.stop="editable ? chooseServiceStatus('worker-status-list-' + serviceArrayIndex + '-' + serviceIndex) : ''"></span>
            <ul class="status-list display-none" v-if="editable"
                :ref="'worker-status-list-' + serviceArrayIndex + '-' + serviceIndex">
              <li
                @click.stop="service.status = 1; chooseServiceStatus('worker-status-list-' + serviceArrayIndex + '-' + serviceIndex)">
                <span class="status send"></span></li>
              <li
                @click.stop="service.status = 2; chooseServiceStatus('worker-status-list-' + serviceArrayIndex + '-' + serviceIndex)">
                <span class="status delivered"></span></li>
              <li
                @click.stop="service.status = 3; chooseServiceStatus('worker-status-list-' + serviceArrayIndex + '-' + serviceIndex)">
                <span class="status confirmed"></span></li>
            </ul>
          </div>
        </div>
        <span class="delete" title="Удалить" @click.stop="editable ? deleteWorker(service.worker.id) : ''"><img
          src="../image/cancel-gray.svg"></span>
        <div
          v-if="isServicePrimary(service) && service.worker && service.hasSmsSent && service.status &&  service.status > 0 && service.status < 4"
          class="send-sms"
          @mouseenter="isEnvelopeBlue = true" @mouseleave="isEnvelopeBlue = false"
          :title="moment(service.smsSentTime).format('Отправлено DD.MM.YY в HH:mm')">
          <div class="sms-info">
            <i :class="{'fa fa-envelope-o': !isEnvelopeBlue, 'fa fa-envelope': isEnvelopeBlue}"></i></div>
        </div>
      </div>
      <div class="workers-time" v-if="isServicePrimary(service)">
        <section>
          <span class="name">Начал</span>
          <fieldset class="value">
            <input type="text"
                   :disabled="!editable"
                   placeholder="hh:mm"
                   v-mask="'##:##'"
                   :value="getTimeStringFromLong(service.realStartTime, false)"
                   @input="editable ? setRealStartTime(service, $event.target.value) : ''"
                   @click.stop="">
          </fieldset>
        </section>
        <span class="dash">-</span>
        <section>
          <span class="name">закончил</span>
          <fieldset class="value">
            <input type="text"
                   :disabled="!editable"
                   placeholder="hh:mm"
                   v-mask="'##:##'"
                   :value="getTimeStringFromLong(service.realEndTime, false)"
                   @input="editable ? setRealEndTime(service, $event.target.value) : ''"
                   @click.stop="">
          </fieldset>
        </section>
        <section class="fact">
          <span class="name">Факт.:</span>
          <span class="data" @click.stop="">{{ getServiceRealDuration(service) }} ч.</span>
        </section>
        <section class="prognosis">
          <span class="name">Прогноз:</span>
          <fieldset class="value">
            <input type="text"
                   :disabled="!editable"
                   placeholder="hh:mm"
                   v-mask="'##:##'"
                   :value="getTimeStringFromLong(service.predictionTime, true)"
                   @blur="editable ? setServicePredictionTime(service, $event.target.value) : ''"
                   @click.stop="">
            <span>ч.</span>
          </fieldset>
        </section>
      </div>
    </div>
    <div class="string" v-show="checkHasServiceArrayServiceWithoutWorker(serviceArray)"
         @click.stop="editable ? changeWorkerListWindowVisibility(true, needfulWorkerType, serviceArray, serviceArrayIndex,
          serviceArray[0].category.name, serviceArray[0].category.id) : ''">
      <span class="add-workers"><i>+</i>Назначить рабочего</span>
    </div>
  </div>
</template>
<script>
    import utils from '@/utils'
    import {mask} from 'vue-the-mask'
    import moment from 'moment'

    export default {
  name: 'WorkersBlock',

  props: ['serviceArrayFromOrder', 'serviceArrayIndex', 'order', 'needfulWorkerType', 'editable'],

  directives: { mask },

  data () {
    return {
      isEnvelopeBlue: false
    }
  },

  computed: {
    serviceArray () {
      return this.$store.getters.groupedServices[this.serviceArrayIndex]
    }
  },

  methods: {
    getServiceStatusTitle (service) {
      let title
      switch (service.status) {
        case 3:
          title = 'Подтверждено'
          break
        case 2:
          title = 'Доставлено'
          break
        case 1:
          title = 'Отправлено'
          break
        default:
          title = ''
      }

      if (service.pushTime) { title += ' ' + moment(service.pushTime).format('DD.MM.YY в HH:mm') }

      return title
    },

    chooseServiceStatus (ref) {
      this.$refs[ref][0].classList.toggle('display-none')
    },

    getTimeStringFromLong (longValue, withTimeZone) {
      return !withTimeZone ? utils.getFormattedTimeStringFromLongWithoutTimezone(longValue)
        : utils.getFormattedTimeStringFromLongWithTimezone(longValue)
    },

    callWorker (worker) {
      alert('Звонок рабочему: ' + worker.name + ', на номер: ' + worker.phone)
    },

    isWorkerBrigadier(worker) {
      return this.order.brigadier
          && worker
          && this.order.brigadier.brigadierId == worker.id;
    },

    isWorkerNewbie(worker) {
      return worker
          && worker.startingDebt
          && worker.startingDebt > 0;
    },

    isServicePrimary(service) {
      return utils.isServicePrimary(service);
    },

    setRealStartTime (service, stringValue) {
      if (stringValue.length === 5) {
        service.realStartTime = null
        let date = new Date(this.order.datetime)
        date.setHours(0, 0, 0, 0)
        service.realStartTime = date.getTime() + utils.getLongFromFormattedTimeString(stringValue)
        if (service.realEndTime && service.realEndTime < service.realStartTime)
          service.realEndTime += 24 * 60 * 60 * 1000;
      }
    },

    setRealEndTime (service, stringValue) {
      if (stringValue.length === 5) {
        service.realEndTime = null
        let date = new Date(this.order.datetime)
        date.setHours(0, 0, 0, 0)
        let tmpEndDate = date.getTime() + utils.getLongFromFormattedTimeString(stringValue)
        service.realEndTime = tmpEndDate >= service.realStartTime
          ? tmpEndDate
          : tmpEndDate + 24 * 60 * 60 * 1000
      }
    },

    getServiceRealDuration (service) {
      if (service.realEndTime && service.realStartTime) { return moment(new Date().getTimezoneOffset() * 60000 + (service.realEndTime - service.realStartTime)).format('HH:mm') }
    },

    setServicePredictionTime (service, stringValue) {
      let timeInMillis

      if (stringValue.length === 5) { timeInMillis = utils.getLongFromFormattedTimeString(stringValue) }

      if (!stringValue.isNaN && (stringValue.length === 1 || stringValue.length === 2)) { timeInMillis = parseInt(stringValue) * 3600000 }

      service.predictionTime = timeInMillis
    },

    checkHasServiceArrayServiceWithoutWorker (serviceArray) {
      for (let service of serviceArray) {
        if (service.worker == null) { return true }
      }

      return false
    },

    deleteWorker (workerId) {
      this.$store.dispatch('deleteWorkerFromServiceByIndex', {
        index: this.serviceArrayIndex,
        workerId: workerId
      });
    },

    changeWorkerListWindowVisibility (value, type, serviceArray, serviceArrayIndex, categoryName, categoryId) {
      this.$emit('changeWorkerListWindowVisibility', value, type, serviceArray, serviceArrayIndex, categoryName, categoryId)
      this.$forceUpdate()
    },

    moment (val) {
      return moment(val)
    }
  }
}
</script>
